module.exports = __webpack_public_path__ + "static/media/visa-logo.1744d9bd.svg";